import React from 'react';
import { Spin } from 'antd';

export const LoadingSpinner = ({ size }) => {
    return (
        <div className="loadingSpinner">
            <Spin size={size || "middle"} />
        </div>
    )
}